import defaultImg from "./default.png"
import aya from './aya.jpeg'

export const avatars = {
    default: defaultImg,
    aya: aya
}

